import { supabase } from "./client";

/**
 * Sets the current tenant ID in the Postgres transaction config
 * so that RLS policies using current_tenant_id() resolve correctly.
 *
 * Must be called whenever the active tenant changes.
 */
let _currentTenantId: string | null = null;
let _jwtTenantId: string | null = null;

export function setActiveTenantId(tenantId: string | null) {
  _currentTenantId = tenantId;
}

export function getActiveTenantId(): string | null {
  return _currentTenantId;
}

/**
 * Executes set_config('app.current_tenant_id', ...) on the current connection
 * AND persists tenant_id in JWT user_metadata for PgBouncer resilience.
 */
export async function syncTenantContext(tenantId: string): Promise<void> {
  // Persist tenant_id in JWT only when it actually changes (avoids auth loop)
  if (_jwtTenantId !== tenantId) {
    _jwtTenantId = tenantId;
    try {
      await supabase.auth.updateUser({ data: { tenant_id: tenantId } });
    } catch (e) {
      console.warn("[setTenantContext] Failed to persist tenant in JWT:", e);
    }
  }

  // Also try set_config (works when connection is stable)
  const { error } = await supabase.rpc("set_tenant_context" as never, {
    p_tenant_id: tenantId,
  } as never);

  if (error) {
    console.error("[setTenantContext] Failed to set tenant context:", error.message);
    import("@sentry/react").then((Sentry) =>
      Sentry.captureException(new Error(`setTenantContext failed: ${error.message}`), {
        tags: { module: "rls" },
        extra: { tenantId },
      })
    );
  }
}
